import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth';
import trajectory_resources from './modules/trajectory-resources';
import profile from './modules/profile';
import work_processes from './modules/work-processes';
import chart from './modules/chart';
import evaluations from './modules/evaluations';
import evaluation from './modules/evaluation';
import pending_evaluations from './modules/pending-evaluations';
import evaluation_students from './modules/evaluation-students';
import trajectories from './modules/trajectories';
import trajectory from './modules/trajectory';
import document_template from './modules/document-template';
import document_template_tags from './modules/document-template-tags';
import document_templates from './modules/document-templates';
import documents from './modules/documents';
import file_resources from './modules/file-resources';
import tests from './modules/tests';
import notes from './modules/notes';
import work_experience from './modules/work-experience';
import work_experience_resources from './modules/work-experience-resources';
import studies from './modules/studies';
import study_resources from './modules/study-resources';
import invoice_resources from './modules/invoice-resources';
import invoice from './modules/invoice';
import invoices from './modules/invoices';
import survey_template from './modules/survey-template';
import survey_templates from './modules/survey-templates';
import survey from './modules/survey';
import surveys from './modules/surveys';
import applications from './modules/applications';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        auth,
        trajectory_resources,
        work_processes,
        profile,
        evaluation_students,
        trajectories,
        evaluations,
        pending_evaluations,
        evaluation,
        chart,
        trajectory,
        document_template,
        document_template_tags,
        document_templates,
        documents,
        file_resources,
        tests,
        notes,
        work_experience,
        work_experience_resources,
        studies,
        study_resources,
        invoice_resources,
        invoice,
        invoices,
        survey_template,
        survey_templates,
        survey,
        surveys,
        applications,
    }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js